import mapboxgl from 'mapbox-gl';

// Mapbox configuration object
export const MAPBOX_CONFIG = {
  token: 'pk.eyJ1IjoiZ29uemFsb2dtZzA5IiwiYSI6ImNtOTJ5YjZ4azBjNWIyanM5cmR5OXV2ZWcifQ.y3YQ3hW0KdoP_D_hjVkZuw',
  defaultStyle: 'mapbox://styles/mapbox/streets-v12',
  defaultCenter: {
    latitude: -33.4569, // Default to Santiago, Chile
    longitude: -70.6483,
  },
  defaultZoom: 10,
};

// Initialize Mapbox
mapboxgl.accessToken = MAPBOX_CONFIG.token;

// Custom truck marker element
export const createTruckMarker = (color: string) => {
  const el = document.createElement('div');
  el.className = 'truck-marker';
  el.style.width = '30px';
  el.style.height = '30px';
  el.style.backgroundImage = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='${encodeURIComponent(color)}'%3E%3Cpath d='M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'/%3E%3C/svg%3E")`;
  el.style.backgroundSize = 'contain';
  el.style.backgroundRepeat = 'no-repeat';
  el.style.backgroundPosition = 'center';
  return el;
};

// Create pulsing dot element
export const createPulsingDot = (color: string) => {
  const size = 100;
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const context = canvas.getContext('2d');

  if (!context) {
    throw new Error('Failed to get canvas context for pulsing dot');
  }

  const render = () => {
    const duration = 1000;
    const t = (window.performance.now() % duration) / duration;

    const radius = (size / 2) * 0.3;
    const outerRadius = (size / 2) * 0.7 * t + radius;

    // Draw the outer circle
    context.clearRect(0, 0, size, size);
    context.beginPath();
    context.arc(size / 2, size / 2, outerRadius, 0, Math.PI * 2);
    context.fillStyle = `rgba(${color}, ${1 - t})`;
    context.fill();

    // Draw the inner circle
    context.beginPath();
    context.arc(size / 2, size / 2, radius, 0, Math.PI * 2);
    context.fillStyle = `rgba(${color}, 1)`;
    context.strokeStyle = 'white';
    context.lineWidth = 2 + 4 * (1 - t);
    context.fill();
    context.stroke();

    return true;
  };

  return { canvas, render };
};

// Calculate bounds for all coordinates
export const calculateBounds = (
  operations: Array<{
    centroidLocation?: {
      latitude: number;
      longitude: number;
    };
  }>
) => {
  if (operations.length === 0) return null;

  const bounds = new mapboxgl.LngLatBounds();
  operations.forEach((operation) => {
    if (operation.centroidLocation) {
      bounds.extend([operation.centroidLocation.longitude, operation.centroidLocation.latitude]);
    }
  });
  return bounds.isEmpty() ? null : bounds;
};
